import './tailwind.css';

import React, { Component } from 'react';
import { UIRouter, UIView } from '@uirouter/react';
import router from './router/router';
import {$state} from './router';
import { connect } from 'react-redux';
import APP_CONST from './constants';
import AppHeader from './components/app-header/app-header';
import { GeckoLogoHeader, Toaster, GeckoBtn } from './components';
import { HeartHandshake } from 'lucide-react';

const LAYOUT_PREFIX = 'global_app_layout_';

export class App extends Component {

    renderFullLayout() {
        if (this.props.layout !== APP_CONST.LAYOUT_FULL) return null;

        const headerButtons = ($state.current.headerButtons ? $state.current.headerButtons : null);

        return (
            <div id={LAYOUT_PREFIX + APP_CONST.LAYOUT_FULL} className="bg-white min-h-screen">
                
                <AppHeader buttons={headerButtons} />

                <div className="app-body max-w-6xl mx-auto px-3">
                    <UIView />
                </div>

            </div>
        );
    }

    renderPartialLayout() {
        if (this.props.layout !== APP_CONST.LAYOUT_PARTIAL) return null;
        
        return (
            <div id={LAYOUT_PREFIX + APP_CONST.LAYOUT_PARTIAL} className="min-h-screen flex items-center justify-center p-5">
                <div className="absolute overflow-hidden top-0 h-[200px] w-1/2 left-0 right-0 mx-auto">
                    <div className="absolute bg-[linear-gradient(to_right,oklch(92.9%_0.013_255.508)_1px,transparent_1px),linear-gradient(to_bottom,oklch(92.9%_0.013_255.508)_1px,transparent_1px)] bg-[size:24px_24px] inset-0 opacity-50"></div>
                    <div className="absolute bg-gradient-to-b from-transparent to-slate-50 inset-0"></div>
                    <div className="absolute bg-gradient-to-r from-slate-50 via-transparent to-slate-50 inset-0"></div>
                </div>

                <div className="w-full max-w-md flex flex-col items-center justify-center gap-4 relative z-10">
                    <GeckoLogoHeader />
                    <UIView />
                    <div className="flex justify-center">
                        <GeckoBtn
                            name="Status page"
                            icon={HeartHandshake}
                            type={APP_CONST.BTN_TYPE_GHOST}
                            size={APP_CONST.BTN_SIZE_SM}
                            handler={() => {
                                window.open('https://status.geckoform.com/', '_blank', 'noopener,noreferrer');
                            }}
                        />
                    </div>
                </div>

                <div className="absolute overflow-hidden bottom-0 h-[160px] w-1/2 left-0 right-0 mx-auto opacity-70">
                    <div className="absolute bg-[linear-gradient(to_right,oklch(92.9%_0.013_255.508)_1px,transparent_1px),linear-gradient(to_bottom,oklch(92.9%_0.013_255.508)_1px,transparent_1px)] bg-[size:24px_24px] inset-0"></div>
                    <div className="absolute bg-gradient-to-b from-slate-50 to-transparent inset-0"></div>
                    <div className="absolute bg-gradient-to-r from-slate-50 via-transparent to-slate-50 inset-0"></div>
                </div>
            </div>
        );
    }

    render() {
        const current_page = 'app-page-' + $state.$current.name;

        return (
            <UIRouter router={router}>
                <div id={current_page} className="bg-slate-50 min-h-screen">

                    {this.renderFullLayout()}

                    {this.renderPartialLayout()}

                    <Toaster />
                </div>
            </UIRouter>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        layout: store.layout,
        user: store.user || {}
    }
};

export default connect(mapStateToProps)(App);